import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants";
import { ProductDetailsData } from "../../product.types";

export const requestGetProductById = async (
  productId: string
): Promise<ProductDetailsData> => {
  return await instance.get(buildUrl(ApiRoutesProducts.OneProduct, productId));
};
